<div class="container-fluid">
  <div class="card shadow-sm" style="border-radius: 10px">
    <div class="card-body">
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12">
          <h1 class="text-bold-400 mb-2" style="color: #00726A;">
            Estatísticas de Conferência
          </h1>
          <p class="mb-2 mt-2" style="font-size: 20px">
            Tenha uma visão panorâmica das informações dos servidores na base de dados através dos indicadores e métricas.
          </p>
        </div>
      </div>

      <!-- Tabs -->
      <ngb-tabset type="tabs" (tabChange)="onTabChange($event)" [activeId]="activeTab">
    <!-- Tab Visão Geral -->
    <ngb-tab id="visao-geral" title="Visão Geral">
      <ng-template ngbTabContent>
        <div class="mt-4">
          <!-- Situação de Conferência Geral (Base) -->
          <div class="row mb-4">
            <div class="col-12">
              <h3 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 20px;">Situação de Conferência</h3>
              <p class="text-muted mb-3" style="font-size: 14px; color: #1D1D1D;">Geral (Base)</p>
              
              <div class="row">
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos Hoje</h5>
                          <div class="estatistica-numero mb-0">{{ estatisticasGerais.conferimentosHoje }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos na Semana</h5>
                          <div class="estatistica-numero mb-0">{{ estatisticasGerais.conferimentosSemana }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos no Mês</h5>
                          <div class="estatistica-numero mb-0">{{ estatisticasGerais.conferimentosMes }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Município -->
          <div class="row mb-4">
            <div class="col-12">
              <h3 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Município</h3>
              
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="municipio" style="font-size: 14px; color: #1D1D1D;">MUNICÍPIO</label>
                    <ng-select
                      [items]="municipios"
                      bindLabel="nome"
                      bindValue="id"
                      [(ngModel)]="municipioIdSelecionado"
                      name="municipio"
                      id="municipio"
                      placeholder="Selecione um Município"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="municipiosLoading"
                      (search)="onMunicipioSearch($event)"
                      (scrollToEnd)="onMunicipioScrollToEnd()"
                      (change)="onMunicipioChange($event)"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos Hoje</h5>
                          <div class="estatistica-numero mb-0">{{ municipioIdSelecionado ? estatisticasMunicipio.conferimentosHoje : '--' }}</div>
                        </div>
                      </div>
                      <div class="progress mt-3" style="height: 8px;">
                        <div class="progress-bar" role="progressbar" 
                             [style.width.%]="municipioIdSelecionado ? estatisticasMunicipio.percentualHoje : 0"
                             [style.backgroundColor]="'#83C4F0'"
                             [attr.aria-valuenow]="municipioIdSelecionado ? estatisticasMunicipio.percentualHoje : 0"
                             aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                      <small class="text-muted mt-1 d-block">({{ municipioIdSelecionado ? estatisticasMunicipio.percentualHoje : 0 }}%)</small>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos na Semana</h5>
                          <div class="estatistica-numero mb-0">{{ municipioIdSelecionado ? estatisticasMunicipio.conferimentosSemana : '--' }}</div>
                        </div>
                      </div>
                      <div class="progress mt-3" style="height: 8px;">
                        <div class="progress-bar" role="progressbar" 
                             [style.width.%]="municipioIdSelecionado ? estatisticasMunicipio.percentualSemana : 0"
                             [style.backgroundColor]="'#83C4F0'"
                             [attr.aria-valuenow]="municipioIdSelecionado ? estatisticasMunicipio.percentualSemana : 0"
                             aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                      <small class="text-muted mt-1 d-block">({{ municipioIdSelecionado ? estatisticasMunicipio.percentualSemana : 0 }}%)</small>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-3">
                  <div class="card shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="estatistica-icon mr-3">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M56.4718 15.1648V54.0355C56.4718 56.9619 54.0976 59.3361 51.1712 59.3361H12.3005C9.3742 59.3361 7 56.9619 7 54.0355V15.1648C7 12.2385 9.3742 9.86427 12.3005 9.86427H17.6011V4.12201C17.6011 3.39319 18.1974 2.79688 18.9262 2.79688H23.3434C24.0722 2.79688 24.6685 3.39319 24.6685 4.12201V9.86427H38.8033V4.12201C38.8033 3.39319 39.3996 2.79688 40.1284 2.79688H44.5456C45.2744 2.79688 45.8707 3.39319 45.8707 4.12201V9.86427H51.1712C54.0976 9.86427 56.4718 12.2385 56.4718 15.1648ZM51.1712 53.3729V20.4654H12.3005V53.3729C12.3005 53.7374 12.5987 54.0355 12.9631 54.0355H50.5087C50.8731 54.0355 51.1712 53.7374 51.1712 53.3729Z" fill="#279590"/>
                          <path d="M29.5283 28.0469H33.9453C34.398 28.0469 34.7705 28.4194 34.7705 28.8721V33.2891C34.7705 33.7417 34.398 34.1143 33.9453 34.1143H29.5283C29.0756 34.1143 28.7031 33.7417 28.7031 33.2891V28.8721C28.7031 28.4194 29.0756 28.0469 29.5283 28.0469Z" stroke="#279590"/>
                          <path d="M40.1064 28.0469H44.5234C44.9761 28.0469 45.3486 28.4194 45.3486 28.8721V33.2891C45.3486 33.7417 44.9761 34.1143 44.5234 34.1143H40.1064C39.6538 34.1143 39.2812 33.7417 39.2812 33.2891V28.8721C39.2812 28.4194 39.6538 28.0469 40.1064 28.0469Z" stroke="#279590"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5986 33.2891V28.872C24.5986 28.1432 24.0023 27.5469 23.2735 27.5469H18.8564C18.1276 27.5469 17.5312 28.1432 17.5312 28.872V33.2891C17.5312 34.018 18.1276 34.6143 18.8564 34.6143H23.2735C24.0023 34.6143 24.5986 34.018 24.5986 33.2891Z" fill="#279590"/>
                          <path d="M18.8564 38.5781H23.2734C23.7261 38.5781 24.0986 38.9506 24.0986 39.4033V43.8203C24.0986 44.273 23.7261 44.6455 23.2734 44.6455H18.8564C18.4038 44.6455 18.0312 44.273 18.0312 43.8203V39.4033C18.0312 38.9506 18.4038 38.5781 18.8564 38.5781Z" stroke="#279590"/>
                          <path d="M40.1064 38.5781H44.5234C44.9761 38.5781 45.3486 38.9506 45.3486 39.4033V43.8203C45.3486 44.273 44.9761 44.6455 44.5234 44.6455H40.1064C39.6538 44.6455 39.2812 44.273 39.2812 43.8203V39.4033C39.2812 38.9506 39.6538 38.5781 40.1064 38.5781Z" stroke="#279590"/>
                          <path d="M29.4814 38.5781H33.8984C34.3511 38.5781 34.7236 38.9506 34.7236 39.4033V43.8203C34.7236 44.273 34.3511 44.6455 33.8984 44.6455H29.4814C29.0288 44.6455 28.6562 44.273 28.6562 43.8203V39.4033C28.6562 38.9506 29.0288 38.5781 29.4814 38.5781Z" stroke="#279590"/>
                        </svg>
                        <div>
                          <h5 class="estatistica-titulo mb-1">Conferimentos no Mês</h5>
                          <div class="estatistica-numero mb-0">{{ municipioIdSelecionado ? estatisticasMunicipio.conferimentosMes : '--' }}</div>
                        </div>
                      </div>
                      <div class="progress mt-3" style="height: 8px;">
                        <div class="progress-bar" role="progressbar" 
                             [style.width.%]="municipioIdSelecionado ? estatisticasMunicipio.percentualMes : 0"
                             [style.backgroundColor]="'#83C4F0'"
                             [attr.aria-valuenow]="municipioIdSelecionado ? estatisticasMunicipio.percentualMes : 0"
                             aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                      <small class="text-muted mt-1 d-block">({{ municipioIdSelecionado ? estatisticasMunicipio.percentualMes : 0 }}%)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Situação por Conferidores -->
          <div class="row mb-4">
            <div class="col-12">
              <h3 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Situação por Conferidores</h3>
              
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="input-group">
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="NOME" 
                      [(ngModel)]="conferidorBusca"
                      (keyup.enter)="buscarConferidor()"
                    >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" (click)="buscarConferidor()">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card shadow-sm">
                <div class="card-body">
                  <h6 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 18px;">Geral</h6>
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th (click)="sortTable('nome')" style="cursor: pointer;">
                            Nome
                            <i class="fa fa-sort ml-1" *ngIf="currentSortColumn !== 'nome'"></i>
                            <i class="fa fa-sort-up ml-1" *ngIf="currentSortColumn === 'nome' && currentSortDirection === 'asc'"></i>
                            <i class="fa fa-sort-down ml-1" *ngIf="currentSortColumn === 'nome' && currentSortDirection === 'desc'"></i>
                          </th>
                          <th>ID</th>
                          <th (click)="sortTable('hoje')" style="cursor: pointer;">
                            Hoje
                            <i class="fa fa-sort ml-1" *ngIf="currentSortColumn !== 'hoje'"></i>
                            <i class="fa fa-sort-up ml-1" *ngIf="currentSortColumn === 'hoje' && currentSortDirection === 'asc'"></i>
                            <i class="fa fa-sort-down ml-1" *ngIf="currentSortColumn === 'hoje' && currentSortDirection === 'desc'"></i>
                          </th>
                          <th (click)="sortTable('semana')" style="cursor: pointer;">
                            Semana
                            <i class="fa fa-sort ml-1" *ngIf="currentSortColumn !== 'semana'"></i>
                            <i class="fa fa-sort-up ml-1" *ngIf="currentSortColumn === 'semana' && currentSortDirection === 'asc'"></i>
                            <i class="fa fa-sort-down ml-1" *ngIf="currentSortColumn === 'semana' && currentSortDirection === 'desc'"></i>
                          </th>
                          <th (click)="sortTable('mes')" style="cursor: pointer;">
                            Mês
                            <i class="fa fa-sort ml-1" *ngIf="currentSortColumn !== 'mes'"></i>
                            <i class="fa fa-sort-up ml-1" *ngIf="currentSortColumn === 'mes' && currentSortDirection === 'asc'"></i>
                            <i class="fa fa-sort-down ml-1" *ngIf="currentSortColumn === 'mes' && currentSortDirection === 'desc'"></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let conferidor of getConferidoresPaginados()">
                          <td>
                            <i class="fa fa-user mr-2 text-muted"></i>
                            {{ conferidor.nome }}
                          </td>
                          <td>{{ conferidor.id }}</td>
                          <td>{{ conferidor.hoje }}</td>
                          <td>{{ conferidor.semana }}</td>
                          <td>{{ conferidor.mes }}</td>
                        </tr>
                        <tr *ngIf="getConferidoresPaginados().length === 0">
                          <td colspan="5" class="text-center text-muted">Nenhum conferidor encontrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <!-- Paginação -->
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      <span class="text-muted">
                        Exibindo {{ (page - 1) * pageSize + 1 }} a {{ Math.min(page * pageSize, totalConferidores) }} de {{ totalConferidores }} itens
                      </span>
                    </div>
                    <nav>
                      <ul class="pagination mb-0">
                        <li class="page-item" [class.disabled]="page === 1">
                          <a class="page-link" (click)="changePage(page - 1)" style="cursor: pointer;">«</a>
                        </li>
                        <ng-container *ngFor="let p of getPagesArray(); let i = index">
                          <li class="page-item" *ngIf="shouldShowPage(p)" 
                              [class.active]="page === p">
                            <a class="page-link" (click)="changePage(p)" style="cursor: pointer;">{{ p }}</a>
                          </li>
                          <li class="page-item disabled" *ngIf="shouldShowEllipsis(i)">
                            <span class="page-link">...</span>
                          </li>
                        </ng-container>
                        <li class="page-item" [class.disabled]="page === getTotalPages()">
                          <a class="page-link" (click)="changePage(page + 1)" style="cursor: pointer;">»</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <!-- Tab Detalhes (Geral) -->
    <ngb-tab id="detalhes-geral" title="Detalhes (Geral)">
      <ng-template ngbTabContent>
        <div class="mt-4">
          <!-- Filtros -->
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-4 col-lg-3 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesGeralMunicipio" style="font-size: 14px; color: #1D1D1D;">MUNICÍPIO</label>
                    <ng-select
                      [items]="municipios"
                      bindLabel="nome"
                      bindValue="id"
                      [(ngModel)]="detalhesGeralMunicipioId"
                      name="detalhesGeralMunicipio"
                      id="detalhesGeralMunicipio"
                      placeholder="Selecione um Município"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="municipiosLoading"
                      (search)="onMunicipioSearch($event)"
                      (scrollToEnd)="onMunicipioScrollToEnd()"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesGeralDataInicio" style="font-size: 14px; color: #1D1D1D;">PERÍODO</label>
                    <div class="d-flex align-items-center">
                      <input 
                        type="date" 
                        class="form-control" 
                        id="detalhesGeralDataInicio"
                        [(ngModel)]="detalhesGeralDataInicio"
                        name="detalhesGeralDataInicio"
                        style="min-width: 0; flex: 1;"
                      >
                      <span class="mx-2" style="white-space: nowrap;">até</span>
                      <input 
                        type="date" 
                        class="form-control" 
                        id="detalhesGeralDataFim"
                        [(ngModel)]="detalhesGeralDataFim"
                        name="detalhesGeralDataFim"
                        style="min-width: 0; flex: 1;"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesGeralAgruparPor" style="font-size: 14px; color: #1D1D1D;">AGRUPAR EM</label>
                    <select 
                      class="form-control" 
                      id="detalhesGeralAgruparPor"
                      [(ngModel)]="detalhesGeralAgruparPorTemp"
                      name="detalhesGeralAgruparPor"
                    >
                      <option value="dia">Dias</option>
                      <option value="semana">Semanas</option>
                      <option value="mes">Meses</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="form-group">
                    <label style="font-size: 14px; color: transparent;">Ações</label>
                    <div class="d-flex flex-wrap" style="gap: 10px;">
                      <button 
                        class="btn btn-outline-primary flex-fill flex-md-grow-0 flex-lg-grow-0" 
                        type="button" 
                        (click)="removerFiltrosDetalhesGeral()"
                        title="Remover Filtros"
                      >
                        <i class="fa fa-times"></i> Remover Filtros
                      </button>
                      <button 
                        class="btn btn-outline-primary flex-fill flex-md-grow-0 flex-lg-grow-0" 
                        type="button" 
                        (click)="aplicarFiltrosDetalhesGeral()"
                        title="Aplicar Filtros"
                      >
                        <i class="fa fa-search"></i> Aplicar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="detalhesGeralMunicipioId || detalhesGeralDataInicio" style="margin-top: 25px;">
                <div class="col-12">
                  <p class="text-muted mb-0" style="font-size: 23px; text-align: center;">
                    Mostrando dados do censo de 
                    <span *ngIf="detalhesGeralDataInicio" style="color: #00726A; font-weight: 500;">{{ detalhesGeralDataInicio | date:'dd-MMM-yyyy' }}</span>
                    <span *ngIf="!detalhesGeralDataInicio">início</span>
                    até 
                    <span *ngIf="detalhesGeralDataFim" style="color: #00726A; font-weight: 500;">{{ detalhesGeralDataFim | date:'dd-MMM-yyyy' }}</span>
                    <span *ngIf="!detalhesGeralDataFim">fim</span>
                    <span *ngIf="detalhesGeralMunicipioId">
                      do município de <span style="color: #00726A; font-weight: 500;">{{ getNomeMunicipioSelecionado() }}</span>
                    </span>
                    agrupados por 
                    <span *ngIf="detalhesGeralAgruparPor === 'dia'" style="color: #00726A; font-weight: 500;">dias</span>
                    <span *ngIf="detalhesGeralAgruparPor === 'semana'" style="color: #00726A; font-weight: 500;">semanas</span>
                    <span *ngIf="detalhesGeralAgruparPor === 'mes'" style="color: #00726A; font-weight: 500;">meses</span>.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 1: Situação de Conferência -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Situação de Conferência</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Situação</th>
                          <th class="servidores-header">Servidores</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Em processo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.total_servidores !== null && detalhesGeraisHoje.total_servidores !== undefined ? detalhesGeraisHoje.total_servidores : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Pendente</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.situacao_pendente !== null && detalhesGeraisHoje.situacao_pendente !== undefined ? detalhesGeraisHoje.situacao_pendente : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferindo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.situacao_em_conferencia !== null && detalhesGeraisHoje.situacao_em_conferencia !== undefined ? detalhesGeraisHoje.situacao_em_conferencia : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferido</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.situacao_conferido !== null && detalhesGeraisHoje.situacao_conferido !== undefined ? detalhesGeraisHoje.situacao_conferido : 0 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-situacao-conferencia" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'total_registros') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'situacao_pendente') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'situacao_em_conferencia') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'situacao_conferido') }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-situacao-conferencia')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 2: Eficiência -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Eficiência</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Eficiência Média %</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.eficiencia_media_percentual !== null && detalhesGeraisHoje.eficiencia_media_percentual !== undefined ? (detalhesGeraisHoje.eficiencia_media_percentual | number:'1.0-0') + '%' : '0%' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferidores Cadastrados</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.conferidores_cadastrados !== null && detalhesGeraisHoje.conferidores_cadastrados !== undefined ? detalhesGeraisHoje.conferidores_cadastrados : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Cadastros em média/dia</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.media_conferimentos_por_dia !== null && detalhesGeraisHoje.media_conferimentos_por_dia !== undefined ? (detalhesGeraisHoje.media_conferimentos_por_dia | number:'1.0-2') : '0.00' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferimentos por Conferidor em média/dia</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.conferimentos_por_dia_por_conferidor !== null && detalhesGeraisHoje.conferimentos_por_dia_por_conferidor !== undefined ? (detalhesGeraisHoje.conferimentos_por_dia_por_conferidor | number:'1.0-2') : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-eficiencia" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'eficiencia_media_percentual') !== null && getValorPorPeriodo(periodo, 'eficiencia_media_percentual') !== undefined && getValorPorPeriodo(periodo, 'eficiencia_media_percentual') !== 0 ? (getValorPorPeriodo(periodo, 'eficiencia_media_percentual') | number:'1.0-0') + '%' : '0%' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'total_servidores') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'media_conferimentos_por_dia') !== null && getValorPorPeriodo(periodo, 'media_conferimentos_por_dia') !== undefined && getValorPorPeriodo(periodo, 'media_conferimentos_por_dia') !== 0 ? (getValorPorPeriodo(periodo, 'media_conferimentos_por_dia') | number:'1.0-2') : '0.00' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'conferimentos_por_dia_por_conferidor') !== null && getValorPorPeriodo(periodo, 'conferimentos_por_dia_por_conferidor') !== undefined && getValorPorPeriodo(periodo, 'conferimentos_por_dia_por_conferidor') !== 0 ? (getValorPorPeriodo(periodo, 'conferimentos_por_dia_por_conferidor') | number:'1.0-2') : '0.00' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-eficiencia')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 3: Tempo de Processo (Pendente → Conferido) -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempo de Processo (Pendente → Conferido)</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.tempo_medio_processo !== null && detalhesGeraisHoje.tempo_medio_processo !== undefined ? formatarTempo(detalhesGeraisHoje.tempo_medio_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.maior_tempo_processo !== null && detalhesGeraisHoje.maior_tempo_processo !== undefined ? formatarTempo(detalhesGeraisHoje.maior_tempo_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.menor_tempo_processo !== null && detalhesGeraisHoje.menor_tempo_processo !== undefined ? formatarTempo(detalhesGeraisHoje.menor_tempo_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.mediana_tempo_processo !== null && detalhesGeraisHoje.mediana_tempo_processo !== undefined ? formatarTempo(detalhesGeraisHoje.mediana_tempo_processo) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-processo" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'tempo_medio_processo_pendente') !== null && getValorPorPeriodo(periodo, 'tempo_medio_processo_pendente') !== undefined && getValorPorPeriodo(periodo, 'tempo_medio_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'tempo_medio_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'maior_tempo_processo_pendente') !== null && getValorPorPeriodo(periodo, 'maior_tempo_processo_pendente') !== undefined && getValorPorPeriodo(periodo, 'maior_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'maior_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'menor_tempo_processo_pendente') !== null && getValorPorPeriodo(periodo, 'menor_tempo_processo_pendente') !== undefined && getValorPorPeriodo(periodo, 'menor_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'menor_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'mediana_tempo_processo_pendente') !== null && getValorPorPeriodo(periodo, 'mediana_tempo_processo_pendente') !== undefined && getValorPorPeriodo(periodo, 'mediana_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'mediana_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-processo')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 4: Tempos de Conferência (Conferindo → Conferido) -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos de Conferência (Conferindo → Conferido)</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.tempo_medio_conferencia !== null && detalhesGeraisHoje.tempo_medio_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.tempo_medio_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.maior_tempo_conferencia !== null && detalhesGeraisHoje.maior_tempo_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.maior_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.menor_tempo_conferencia !== null && detalhesGeraisHoje.menor_tempo_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.menor_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.mediana_tempo_conferencia !== null && detalhesGeraisHoje.mediana_tempo_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.mediana_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-conferencia" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'tempo_medio_conferencia') !== null && getValorPorPeriodo(periodo, 'tempo_medio_conferencia') !== undefined && getValorPorPeriodo(periodo, 'tempo_medio_conferencia') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'tempo_medio_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'maior_tempo_conferencia') !== null && getValorPorPeriodo(periodo, 'maior_tempo_conferencia') !== undefined && getValorPorPeriodo(periodo, 'maior_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'maior_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'menor_tempo_conferencia') !== null && getValorPorPeriodo(periodo, 'menor_tempo_conferencia') !== undefined && getValorPorPeriodo(periodo, 'menor_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'menor_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'mediana_tempo_conferencia') !== null && getValorPorPeriodo(periodo, 'mediana_tempo_conferencia') !== undefined && getValorPorPeriodo(periodo, 'mediana_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'mediana_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-conferencia')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 5: Tempos em "Pendente" -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos em "Pendente"</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.tempo_medio_pendente !== null && detalhesGeraisHoje.tempo_medio_pendente !== undefined ? formatarTempo(detalhesGeraisHoje.tempo_medio_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.maior_tempo_pendente !== null && detalhesGeraisHoje.maior_tempo_pendente !== undefined ? formatarTempo(detalhesGeraisHoje.maior_tempo_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.menor_tempo_pendente !== null && detalhesGeraisHoje.menor_tempo_pendente !== undefined ? formatarTempo(detalhesGeraisHoje.menor_tempo_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.mediana_tempo_pendente !== null && detalhesGeraisHoje.mediana_tempo_pendente !== undefined ? formatarTempo(detalhesGeraisHoje.mediana_tempo_pendente) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-pendente" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'tempo_medio_pendente') !== null && getValorPorPeriodo(periodo, 'tempo_medio_pendente') !== undefined && getValorPorPeriodo(periodo, 'tempo_medio_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'tempo_medio_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'maior_tempo_pendente') !== null && getValorPorPeriodo(periodo, 'maior_tempo_pendente') !== undefined && getValorPorPeriodo(periodo, 'maior_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'maior_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'menor_tempo_pendente') !== null && getValorPorPeriodo(periodo, 'menor_tempo_pendente') !== undefined && getValorPorPeriodo(periodo, 'menor_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'menor_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'mediana_tempo_pendente') !== null && getValorPorPeriodo(periodo, 'mediana_tempo_pendente') !== undefined && getValorPorPeriodo(periodo, 'mediana_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'mediana_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-pendente')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 6: Tempos em "Conferindo" -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos em "Conferindo"</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.tempo_medio_em_conferencia !== null && detalhesGeraisHoje.tempo_medio_em_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.tempo_medio_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.maior_tempo_em_conferencia !== null && detalhesGeraisHoje.maior_tempo_em_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.maior_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.menor_tempo_em_conferencia !== null && detalhesGeraisHoje.menor_tempo_em_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.menor_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesGeraisHoje.mediana_tempo_em_conferencia !== null && detalhesGeraisHoje.mediana_tempo_em_conferencia !== undefined ? formatarTempo(detalhesGeraisHoje.mediana_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-conferindo" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupados()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'tempo_medio_conferindo') !== null && getValorPorPeriodo(periodo, 'tempo_medio_conferindo') !== undefined && getValorPorPeriodo(periodo, 'tempo_medio_conferindo') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'tempo_medio_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'maior_tempo_conferindo') !== null && getValorPorPeriodo(periodo, 'maior_tempo_conferindo') !== undefined && getValorPorPeriodo(periodo, 'maior_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'maior_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'menor_tempo_conferindo') !== null && getValorPorPeriodo(periodo, 'menor_tempo_conferindo') !== undefined && getValorPorPeriodo(periodo, 'menor_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'menor_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupados()" class="analise-cell">
                            {{ getValorPorPeriodo(periodo, 'mediana_tempo_conferindo') !== null && getValorPorPeriodo(periodo, 'mediana_tempo_conferindo') !== undefined && getValorPorPeriodo(periodo, 'mediana_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodo(periodo, 'mediana_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-conferindo')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <!-- Tab Detalhes (Conferidores) -->
    <ngb-tab id="detalhes-conferidores" title="Detalhes (Conferidores)">
      <ng-template ngbTabContent>
        <div class="mt-4">
          <!-- Filtros -->
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-4 col-lg-3 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesConferidor" style="font-size: 14px; color: #1D1D1D;">CONFERIDOR</label>
                    <select 
                      class="form-control" 
                      id="detalhesConferidor"
                      [(ngModel)]="detalhesConferidorId"
                      name="detalhesConferidor"
                    >
                      <option [value]="null">Todos os Conferidores</option>
                      <option *ngFor="let conf of conferidores" [value]="conf.id">{{ conf.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesConferidorDataInicio" style="font-size: 14px; color: #1D1D1D;">PERÍODO</label>
                    <div class="d-flex align-items-center">
                      <input 
                        type="date" 
                        class="form-control" 
                        id="detalhesConferidorDataInicio"
                        [(ngModel)]="detalhesConferidorDataInicio"
                        name="detalhesConferidorDataInicio"
                        style="min-width: 0; flex: 1;"
                      >
                      <span class="mx-2" style="white-space: nowrap;">até</span>
                      <input 
                        type="date" 
                        class="form-control" 
                        id="detalhesConferidorDataFim"
                        [(ngModel)]="detalhesConferidorDataFim"
                        name="detalhesConferidorDataFim"
                        style="min-width: 0; flex: 1;"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="detalhesConferidorAgruparPor" style="font-size: 14px; color: #1D1D1D;">AGRUPAR EM</label>
                    <select 
                      class="form-control" 
                      id="detalhesConferidorAgruparPor"
                      [(ngModel)]="detalhesConferidorAgruparPorTemp"
                      name="detalhesConferidorAgruparPor"
                    >
                      <option value="dia">Dias</option>
                      <option value="semana">Semanas</option>
                      <option value="mes">Meses</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="form-group">
                    <label style="font-size: 14px; color: transparent;">Ações</label>
                    <div class="d-flex flex-wrap" style="gap: 10px;">
                      <button 
                        class="btn btn-outline-primary flex-fill flex-md-grow-0 flex-lg-grow-0" 
                        type="button" 
                        (click)="removerFiltrosDetalhesConferidor()"
                        title="Remover Filtros"
                      >
                        <i class="fa fa-times"></i> Remover Filtros
                      </button>
                      <button 
                        class="btn btn-outline-primary flex-fill flex-md-grow-0 flex-lg-grow-0" 
                        type="button" 
                        (click)="aplicarFiltrosDetalhesConferidor()"
                        title="Aplicar Filtros"
                      >
                        <i class="fa fa-search"></i> Aplicar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="detalhesConferidorId || detalhesConferidorDataInicio" style="margin-top: 25px;">
                <div class="col-12">
                  <p class="text-muted mb-0" style="font-size: 23px; text-align: center;">
                    Mostrando dados do censo de 
                    <span *ngIf="detalhesConferidorDataInicio" style="color: #00726A; font-weight: 500;">{{ detalhesConferidorDataInicio | date:'dd-MMM-yyyy' }}</span>
                    <span *ngIf="!detalhesConferidorDataInicio">início</span>
                    até 
                    <span *ngIf="detalhesConferidorDataFim" style="color: #00726A; font-weight: 500;">{{ detalhesConferidorDataFim | date:'dd-MMM-yyyy' }}</span>
                    <span *ngIf="!detalhesConferidorDataFim">fim</span>
                    <span *ngIf="detalhesConferidorId">
                      do conferidor <span style="color: #00726A; font-weight: 500;">{{ getNomeConferidorSelecionado() }}</span>
                    </span>
                    agrupados por 
                    <span *ngIf="detalhesConferidorAgruparPor === 'dia'" style="color: #00726A; font-weight: 500;">dias</span>
                    <span *ngIf="detalhesConferidorAgruparPor === 'semana'" style="color: #00726A; font-weight: 500;">semanas</span>
                    <span *ngIf="detalhesConferidorAgruparPor === 'mes'" style="color: #00726A; font-weight: 500;">meses</span>.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 1: Situação de Conferência -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Situação de Conferência</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Situação</th>
                          <th class="servidores-header">Servidores</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Em processo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.total_servidores !== null && detalhesConferidorHoje.total_servidores !== undefined ? detalhesConferidorHoje.total_servidores : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Pendente</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.situacao_pendente !== null && detalhesConferidorHoje.situacao_pendente !== undefined ? detalhesConferidorHoje.situacao_pendente : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferindo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.situacao_em_conferencia !== null && detalhesConferidorHoje.situacao_em_conferencia !== undefined ? detalhesConferidorHoje.situacao_em_conferencia : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferido</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.situacao_conferido !== null && detalhesConferidorHoje.situacao_conferido !== undefined ? detalhesConferidorHoje.situacao_conferido : 0 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-situacao-conferencia-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'total_registros') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'situacao_pendente') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'situacao_em_conferencia') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'situacao_conferido') }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-situacao-conferencia-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 2: Eficiência -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Eficiência</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Eficiência Média %</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.eficiencia_media_percentual !== null && detalhesConferidorHoje.eficiencia_media_percentual !== undefined ? (detalhesConferidorHoje.eficiencia_media_percentual | number:'1.0-0') + '%' : '0%' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferidores Cadastrados</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.conferidores_cadastrados !== null && detalhesConferidorHoje.conferidores_cadastrados !== undefined ? detalhesConferidorHoje.conferidores_cadastrados : 0 }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Cadastros em média/dia</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.media_conferimentos_por_dia !== null && detalhesConferidorHoje.media_conferimentos_por_dia !== undefined ? (detalhesConferidorHoje.media_conferimentos_por_dia | number:'1.0-2') : '0.00' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Conferimentos por Conferidor em média/dia</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.conferimentos_por_dia_por_conferidor !== null && detalhesConferidorHoje.conferimentos_por_dia_por_conferidor !== undefined ? (detalhesConferidorHoje.conferimentos_por_dia_por_conferidor | number:'1.0-2') : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-eficiencia-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'eficiencia_media_percentual') !== null && getValorPorPeriodoConferidor(periodo, 'eficiencia_media_percentual') !== undefined && getValorPorPeriodoConferidor(periodo, 'eficiencia_media_percentual') !== 0 ? (getValorPorPeriodoConferidor(periodo, 'eficiencia_media_percentual') | number:'1.0-0') + '%' : '0%' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'total_servidores') }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'media_conferimentos_por_dia') !== null && getValorPorPeriodoConferidor(periodo, 'media_conferimentos_por_dia') !== undefined && getValorPorPeriodoConferidor(periodo, 'media_conferimentos_por_dia') !== 0 ? (getValorPorPeriodoConferidor(periodo, 'media_conferimentos_por_dia') | number:'1.0-2') : '0.00' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'conferimentos_por_dia_por_conferidor') !== null && getValorPorPeriodoConferidor(periodo, 'conferimentos_por_dia_por_conferidor') !== undefined && getValorPorPeriodoConferidor(periodo, 'conferimentos_por_dia_por_conferidor') !== 0 ? (getValorPorPeriodoConferidor(periodo, 'conferimentos_por_dia_por_conferidor') | number:'1.0-2') : '0.00' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-eficiencia-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 3: Tempo de Processo (Pendente → Conferido) -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempo de Processo (Pendente → Conferido)</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.tempo_medio_processo !== null && detalhesConferidorHoje.tempo_medio_processo !== undefined ? formatarTempo(detalhesConferidorHoje.tempo_medio_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.maior_tempo_processo !== null && detalhesConferidorHoje.maior_tempo_processo !== undefined ? formatarTempo(detalhesConferidorHoje.maior_tempo_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.menor_tempo_processo !== null && detalhesConferidorHoje.menor_tempo_processo !== undefined ? formatarTempo(detalhesConferidorHoje.menor_tempo_processo) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.mediana_tempo_processo !== null && detalhesConferidorHoje.mediana_tempo_processo !== undefined ? formatarTempo(detalhesConferidorHoje.mediana_tempo_processo) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-processo-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'tempo_medio_processo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'tempo_medio_processo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'tempo_medio_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'tempo_medio_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'maior_tempo_processo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'maior_tempo_processo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'maior_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'maior_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'menor_tempo_processo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'menor_tempo_processo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'menor_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'menor_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'mediana_tempo_processo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_processo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_processo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'mediana_tempo_processo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-processo-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 4: Tempos de Conferência (Conferindo → Conferido) -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos de Conferência (Conferindo → Conferido)</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.tempo_medio_conferencia !== null && detalhesConferidorHoje.tempo_medio_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.tempo_medio_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.maior_tempo_conferencia !== null && detalhesConferidorHoje.maior_tempo_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.maior_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.menor_tempo_conferencia !== null && detalhesConferidorHoje.menor_tempo_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.menor_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.mediana_tempo_conferencia !== null && detalhesConferidorHoje.mediana_tempo_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.mediana_tempo_conferencia) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-conferencia-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferencia') !== null && getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferencia') !== undefined && getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferencia') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferencia') !== null && getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferencia') !== undefined && getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferencia') !== null && getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferencia') !== undefined && getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferencia') !== null && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferencia') !== undefined && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferencia') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferencia')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-conferencia-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 5: Tempos em "Pendente" -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos em "Pendente"</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.tempo_medio_pendente !== null && detalhesConferidorHoje.tempo_medio_pendente !== undefined ? formatarTempo(detalhesConferidorHoje.tempo_medio_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.maior_tempo_pendente !== null && detalhesConferidorHoje.maior_tempo_pendente !== undefined ? formatarTempo(detalhesConferidorHoje.maior_tempo_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.menor_tempo_pendente !== null && detalhesConferidorHoje.menor_tempo_pendente !== undefined ? formatarTempo(detalhesConferidorHoje.menor_tempo_pendente) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.mediana_tempo_pendente !== null && detalhesConferidorHoje.mediana_tempo_pendente !== undefined ? formatarTempo(detalhesConferidorHoje.mediana_tempo_pendente) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-pendente-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'tempo_medio_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'tempo_medio_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'tempo_medio_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'tempo_medio_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'maior_tempo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'maior_tempo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'maior_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'maior_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'menor_tempo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'menor_tempo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'menor_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'menor_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'mediana_tempo_pendente') !== null && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_pendente') !== undefined && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_pendente') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'mediana_tempo_pendente')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-pendente-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção 6: Tempos em "Conferindo" -->
          <div class="card mb-4" style="box-shadow: none !important; border: none !important;">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Tempos em "Conferindo"</h5>
              <div class="row" style="display: flex;">
                <!-- Tabela: Situação Atual (Hoje) -->
                <div style="padding-right: 10px; width: 35%; flex: 0 0 35%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Situação Atual (Hoje)</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered situacao-hoje-table">
                      <thead>
                        <tr>
                          <th class="situacao-header">Métrica</th>
                          <th class="servidores-header">Tempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="situacao-cell">Tempo Médio</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.tempo_medio_em_conferencia !== null && detalhesConferidorHoje.tempo_medio_em_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.tempo_medio_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Maior Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.maior_tempo_em_conferencia !== null && detalhesConferidorHoje.maior_tempo_em_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.maior_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Menor Tempo</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.menor_tempo_em_conferencia !== null && detalhesConferidorHoje.menor_tempo_em_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.menor_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                        <tr>
                          <td class="situacao-cell">Mediana</td>
                          <td class="servidores-cell">{{ detalhesConferidorHoje.mediana_tempo_em_conferencia !== null && detalhesConferidorHoje.mediana_tempo_em_conferencia !== undefined ? formatarTempo(detalhesConferidorHoje.mediana_tempo_em_conferencia) : '0min.' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Tabela: Análise por período -->
                <div style="padding-left: 10px; width: 65%; flex: 0 0 65%;">
                  <h6 class="mb-2" style="color: #00726A; font-weight: 400; font-size: 16px;">Análise por período (Agrupamento)</h6>
                  <div class="table-responsive analise-periodo-wrapper" id="wrapper-tempo-conferindo-conferidor" style="max-height: 300px; overflow-x: auto; overflow-y: hidden;">
                    <table class="table table-sm analise-periodo-table">
                      <thead>
                        <tr>
                          <th *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-header">{{ periodo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferindo') !== null && getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferindo') !== undefined && getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferindo') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'tempo_medio_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferindo') !== null && getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferindo') !== undefined && getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'maior_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferindo') !== null && getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferindo') !== undefined && getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'menor_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                        <tr>
                          <td *ngFor="let periodo of getPeriodosAgrupadosConferidor()" class="analise-cell">
                            {{ getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferindo') !== null && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferindo') !== undefined && getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferindo') !== 0 ? formatarTempo(getValorPorPeriodoConferidor(periodo, 'mediana_tempo_conferindo')) : '0min.' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button class="btn btn-outline-primary" type="button" (click)="justificarPeriodo('wrapper-tempo-conferindo-conferidor')">
                      <i class="fa fa-list"></i> Justificar Período
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <!-- Tab Matrículas pendentes -->
    <ngb-tab id="matriculas-pendentes" title="Matrículas pendentes">
      <ng-template ngbTabContent>
        <div class="mt-4">
          <div class="alert alert-info" role="alert">
            Esta área permite vincular conferências legadas sem matrícula. Somente matrículas ativas do mesmo servidor e município são apresentadas; o histórico relacionado é atualizado na mesma operação.
          </div>

          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-3 mb-2 mb-md-0">
                  <div class="form-group">
                    <label for="vinculoMunicipio" style="font-size: 14px; color: #1D1D1D;">MUNICÍPIO</label>
                    <ng-select
                      [items]="municipios"
                      bindLabel="nome"
                      bindValue="id"
                      [(ngModel)]="vinculoMunicipioId"
                      name="vinculoMunicipio"
                      id="vinculoMunicipio"
                      placeholder="Todos os municípios"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="municipiosLoading"
                      (search)="onMunicipioSearch($event)"
                      (scrollToEnd)="onMunicipioScrollToEnd()"
                      [virtualScroll]="true">
                    </ng-select>
                  </div>
                </div>

                <div class="col-12 col-md-2 mb-2 mb-md-0">
                  <div class="form-group">
                    <label for="vinculoSituacao" style="font-size: 14px; color: #1D1D1D;">SITUAÇÃO</label>
                    <select class="form-control" id="vinculoSituacao" [(ngModel)]="vinculoSituacao" name="vinculoSituacao">
                      <option value="">Todas</option>
                      <option value="pendente">Pendente</option>
                      <option value="em_conferencia">Em conferência</option>
                      <option value="conferido">Conferido</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 col-md-3 mb-2 mb-md-0">
                  <div class="form-group">
                    <label for="vinculoDataInicio" style="font-size: 14px; color: #1D1D1D;">PERÍODO</label>
                    <div class="d-flex align-items-center">
                      <input type="date" class="form-control" id="vinculoDataInicio" [(ngModel)]="vinculoDataInicio" name="vinculoDataInicio">
                      <span class="mx-2">até</span>
                      <input type="date" class="form-control" id="vinculoDataFim" [(ngModel)]="vinculoDataFim" name="vinculoDataFim">
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label style="font-size: 14px; color: transparent;">Ações</label>
                    <div class="d-flex" style="gap: 10px;">
                      <button class="btn btn-outline-primary" type="button" (click)="removerFiltrosVinculosPendentes()">
                        <i class="fa fa-times"></i> Remover filtros
                      </button>
                      <button class="btn btn-outline-primary" type="button" (click)="aplicarFiltrosVinculosPendentes()">
                        <i class="fa fa-search"></i> Aplicar filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0" style="color: #00726A; font-weight: 400; font-size: 20px;">Conferências sem matrícula</h5>
                <span class="badge badge-warning">{{ totalVinculosPendentes }} pendente(s)</span>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Registro</th>
                      <th>Município</th>
                      <th>Servidor</th>
                      <th>Situação</th>
                      <th>Históricos</th>
                      <th style="min-width: 330px;">Matrícula</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of vinculosPendentes">
                      <td>{{ item.data_registro_formatada || (item.data_registro | date: 'dd/MM/yyyy HH:mm') }}</td>
                      <td>{{ item.nome_municipio || item.id_cidade || 'N/A' }}</td>
                      <td>{{ item.nome_servidor || item.id_servidor }}</td>
                      <td>
                        <span class="badge"
                              [ngClass]="{
                                'badge-secondary': item.situacao === 'pendente',
                                'badge-info': item.situacao === 'em_conferencia',
                                'badge-success': item.situacao === 'conferido'
                              }">
                          {{ item.situacao === 'em_conferencia' ? 'Em conferência' : item.situacao }}
                        </span>
                      </td>
                      <td>{{ item.quantidade_historicos_pendentes || 0 }}</td>
                      <td>
                        <div *ngIf="!item.editando_matricula">
                          <button
                            *ngIf="item.quantidade_matriculas_candidatas > 0"
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            [disabled]="item.carregando_matriculas"
                            (click)="selecionarMatriculaVinculo(item)">
                            <i class="fa fa-link"></i>
                            {{ item.carregando_matriculas ? 'Carregando...' : 'Selecionar matrícula' }}
                          </button>
                          <span *ngIf="item.quantidade_matriculas_candidatas === 0" class="text-danger">
                            Nenhuma matrícula disponível para vinculação
                          </span>
                        </div>

                        <div *ngIf="item.editando_matricula" class="d-flex align-items-center" style="gap: 8px;">
                          <select class="form-control form-control-sm"
                                  [(ngModel)]="item.id_matricula_selecionada"
                                  [name]="'matriculaPendente' + item.id">
                            <option [ngValue]="null">Selecione</option>
                            <option *ngFor="let matricula of item.matriculas_candidatas" [ngValue]="matricula.id">
                              {{ matricula.matricula }}
                            </option>
                          </select>
                          <button type="button"
                                  class="btn btn-sm btn-success"
                                  [disabled]="!item.id_matricula_selecionada || item.salvando_matricula"
                                  (click)="vincularMatricula(item)">
                            Vincular
                          </button>
                          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelarSelecaoMatricula(item)">
                            Cancelar
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="vinculosPendentes.length === 0">
                      <td colspan="6" class="text-center text-muted">Nenhuma conferência sem matrícula encontrada</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="totalVinculosPendentes > 0" class="d-flex justify-content-between align-items-center mt-3">
                <span class="text-muted">
                  Exibindo {{ (pageVinculosPendentes - 1) * pageSizeVinculosPendentes + 1 }} a
                  {{ Math.min(pageVinculosPendentes * pageSizeVinculosPendentes, totalVinculosPendentes) }} de
                  {{ totalVinculosPendentes }} itens
                </span>
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [class.disabled]="pageVinculosPendentes === 1">
                      <a class="page-link" (click)="anteriorVinculosPendentes()" style="cursor: pointer;">«</a>
                    </li>
                    <li class="page-item" *ngFor="let pagina of getPagesArrayVinculosPendentes()" [class.active]="pageVinculosPendentes === pagina">
                      <a class="page-link" (click)="irParaPaginaVinculosPendentes(pagina)" style="cursor: pointer;">{{ pagina }}</a>
                    </li>
                    <li class="page-item" [class.disabled]="pageVinculosPendentes >= getTotalPagesVinculosPendentes()">
                      <a class="page-link" (click)="proximoVinculosPendentes()" style="cursor: pointer;">»</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <!-- Tab Histórico -->
    <ngb-tab id="historico" title="Histórico">
      <ng-template ngbTabContent>
        <div class="mt-4">
          <!-- Filtros -->
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="historicoMunicipio" style="font-size: 14px; color: #1D1D1D;">MUNICÍPIO</label>
                    <ng-select
                      [items]="municipios"
                      bindLabel="nome"
                      bindValue="id"
                      [(ngModel)]="historicoMunicipioId"
                      name="historicoMunicipio"
                      id="historicoMunicipio"
                      placeholder="Selecione um Município"
                      [clearable]="true"
                      [searchable]="true"
                      [loading]="municipiosLoading"
                      (search)="onMunicipioSearch($event)"
                      (scrollToEnd)="onMunicipioScrollToEnd()"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-12 col-md-3 col-lg-2 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="historicoConferidor" style="font-size: 14px; color: #1D1D1D;">CONFERIDOR</label>
                    <select 
                      class="form-control" 
                      id="historicoConferidor"
                      [(ngModel)]="historicoConferidorId"
                      name="historicoConferidor"
                    >
                      <option [value]="null">Todos os Conferidores</option>
                      <option *ngFor="let conf of conferidores" [value]="conf.id">{{ conf.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3 col-lg-3 mb-2 mb-md-0 mb-lg-0">
                  <div class="form-group">
                    <label for="historicoDataInicio" style="font-size: 14px; color: #1D1D1D;">PERÍODO</label>
                    <div class="d-flex align-items-center">
                      <input 
                        type="date" 
                        class="form-control" 
                        id="historicoDataInicio"
                        [(ngModel)]="dataInicioHistorico"
                        name="historicoDataInicio"
                        style="min-width: 0; flex: 1;"
                      >
                      <span class="mx-2" style="white-space: nowrap;">até</span>
                      <input 
                        type="date" 
                        class="form-control" 
                        id="historicoDataFim"
                        [(ngModel)]="dataFimHistorico"
                        name="historicoDataFim"
                        style="min-width: 0; flex: 1;"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3 col-lg-5">
                  <div class="form-group">
                    <label style="font-size: 14px; color: transparent;">Ações</label>
                    <div class="d-flex" style="gap: 10px;">
                      <button 
                        class="btn btn-outline-primary" 
                        type="button" 
                        (click)="removerFiltrosHistorico()"
                        title="Remover Filtros"
                      >
                        <i class="fa fa-times"></i> Remover Filtros
                      </button>
                      <button 
                        class="btn btn-outline-primary" 
                        type="button" 
                        (click)="aplicarFiltrosHistorico()"
                        title="Aplicar Filtros"
                      >
                        <i class="fa fa-search"></i> Aplicar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="card shadow-sm">
            <div class="card-body">
              <h5 class="mb-3" style="color: #00726A; font-weight: 400; font-size: 20px;">Histórico de Importação</h5>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Município</th>
                      <th>Conferidor</th>
                      <th>Servidor</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of historico">
                      <td>{{ item.data_conferencia || (item.data_fim_conferencia | date: 'dd/MM/yyyy HH:mm') }}</td>
                      <td>{{ item.nome_municipio || 'N/A' }}</td>
                      <td>{{ item.nome_conferidor || 'N/A' }}</td>
                      <td>{{ item.nome_servidor || item.id_servidor || 'N/A' }}</td>
                      <td>
                        <span class="badge badge-success">ALTERAÇÃO</span>
                      </td>
                    </tr>
                    <tr *ngIf="historico.length === 0">
                      <td colspan="5" class="text-center text-muted">Nenhum registro encontrado</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <!-- Paginação -->
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <span class="text-muted">
                    Exibindo {{ (pageHistorico - 1) * pageSizeHistorico + 1 }} a 
                    {{ Math.min(pageHistorico * pageSizeHistorico, totalHistorico) }} de 
                    {{ totalHistorico }} itens
                  </span>
                </div>
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [class.disabled]="pageHistorico === 1">
                      <a class="page-link" (click)="anteriorHistorico()" style="cursor: pointer;">«</a>
                    </li>
                    <li class="page-item" *ngFor="let p of getPagesArrayHistorico()" 
                        [class.active]="pageHistorico === p">
                      <a class="page-link" (click)="irParaPaginaHistorico(p)" style="cursor: pointer;">{{ p }}</a>
                    </li>
                    <li class="page-item" [class.disabled]="pageHistorico >= getTotalPagesHistorico()">
                      <a class="page-link" (click)="proximoHistorico()" style="cursor: pointer;">»</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
      </ngb-tabset>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
